export default {
    report_export_history: 'Export History',
    report_export_history_report: 'Report',
    report_export_history_created_on: 'Created On',
    report_export_history_status: 'Status',
    report_export_history_status_updated_on: 'Status Updated On',
    report_export_history_type: 'Type',
    report_export_history_processed_records: 'Processed Records',
    report_export_history_total: 'Total',
    report_export_history_error_message: 'Error Message',
    report_export_history_output_url: 'Download',
    report_export_history_date_range: 'Please select a date range',
    report_export_history_download_error: 'Unable to prepare the file download',
    report_export_history_download_unavailable: 'The file is not available for download',
    report_export_history_status_completed: 'Completed',
    report_export_history_status_pending: 'Pending',
    report_export_history_status_processing: 'Processing',
    report_export_history_status_in_progress: 'In Progress',
    report_export_history_status_failed: 'Failed',
    report_export_history_status_error: 'Error',
    report_export_history_status_cancelled: 'Cancelled',
};
